
import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { isMobile } from "react-device-detect";
import Box from "@mui/material/Box";
import { toDollar } from '../../../utils/dataConverter';

export default function CommonCard({ cardDetails, bold = [], level = 1 }: any) {

  const keys = Object.keys(cardDetails.options);
  const headingLevel = 'h' + (level + 1) as 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  return (
    <Card className='card-root'>
      <CardContent>
        <Typography component={headingLevel} className='title'>{cardDetails.title}</Typography>
        <p className='description'>{cardDetails.cardDescription}</p>
        {keys.map((key: any, index: any) => {
          return (
            <Box key={index} className='options'>
              <Typography className='subtitle'>{key}</Typography>
              <Typography className={'sub-value ' + bold[index] ? 'sub-value-bold' : ''}>
                {toDollar(cardDetails.options[key])}
              </Typography>
            </Box>
          );
        })}
      </CardContent>
    </Card>
  );
}
